<!--
component: Checkbox
author: Ken Nakamura
description: チェックボックス
-->
<template>
  <span>
    <!--<span v-show="!checked">☐</span><span v-show="checked">☑</span>{{ caption }}-->
    <span v-if="checked">{{checkedSymbol}}</span><span v-else>{{uncheckedSymbol}}</span>{{ caption }}
  </span>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
      required: true
    },
    caption: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      checkedSymbol: '■',   //☑✅
      uncheckedSymbol: '☐' //☐□
    }
  }
}
</script>